const color_def = {
    'a': 'blue',
    'A': 'blue',
    'B': 'darkblue',
    'b': 'darkblue',
    'c': 'darkgreen',
    'C': 'darkgreen',
    'd': 'purple',
    'D': 'purple',
    'e': 'oraange',
    'E': 'orange',
    'f': 'darkred',
    'F': 'darkred',
    'g': 'ocra',
    'G': 'ocra',
    'h': 'darkyellow',
    'H': 'darkyellow',
    'i': 'violet',
    'I': 'violet',
    'l': 'lightgreen',
    'L': 'lightgreen',
}
export const stringColour = (s) => {
    if (color_def[s]) {
        return color_def[s]
    } else {
        return '#000'
    }
}


export const globalstyles = {
    input: {
        mr: 1,
        mt: 0,
    },
    input_label: {
        fontStyle: 'italic',
        fontSize: '12px',
        m: 0,
        p: 0,
        mr: 1
    },
    readinput_label: {
        fontSize: '9px',
        fontVariant: 'italic',
        mt: 0.5,
        color: '#aaa'
    },
    secondaryAppBar: {
        marginTop: '70px',
        backgroundColor:'#fff0',
    },
    value_label: {
        fontSize: '12px',
        fontStyle: 'italic',
        color: '#aaa',
        mr: 1
    },
    small: {
        fontSize: '0.8em'
    },
    section_label: {
        color: '#aaa',
        pl: 2,
        mr: 1
    },
    list_row: {
        pb: "1px",
        pt: "1px",
        borderBottom: '1px solid darkgrey'
    },
    elem_row: {
        backgroundClip: 'content-box',
        backgroundColor: '',
        '&:hover': {
            backgroundColor: '#eeeeee55',
        }
    },
    my_container: {
        mt: '3px',
        mb: '3px',
        pl: 1,
        pt: '3px',
        pb: '3px',
        borderLeft: '1px solid darkgreen',
        borderTopLeftRadius: 5,
        borderTop: '1px solid darkgreen',
        borderBottom: '1px solid lightgrey',
        borderBottomLeftRadius: 5,
    },
    list_container: {
        borderLeft: '1px solid darkgreen',
        mt: '3px',
        pl: 1,
        pt: 1,
        borderTopLeftRadius: 5,
        borderTop: '1px solid darkgreen'
    },
    section_container: {
        borderBottom: '1px solid lightgrey',
        borderBottomLeftRadius: 5,
        mb: '3px',
        pb: '3px'
    },
    btn_content: {
        color: 'black',
        position: 'relative',
        fontSize: '10px !important',
        fontStyle: 'italic',
        m: 0,
        pl: 1,
        pr: 1

    },
    element_sharpen: {
        borderBottom: '2px solid orange',
        borderLeft: '2px solid orange',
    },
    listHeader: {
        backgroundColor: '#5e6763',
        fontSize: '12px',
        alignItems: 'center',
        alignContent: 'center',
        color: '#fff',
        marginRight: '1px',
        paddingLeft: 1,
        paddingRight: 1
    },
    sublistHeader: {
        backgroundColor: '#aaa',
        fontSize: '10px',
        alignItems: 'center',
        alignContent: 'center',
        color: '#fff',
        marginRight: '1px',
        paddingLeft: 1,
        paddingRight: 1
    },
    sectionHeader: {
        backgroundColor: 'green',
        fontSize: '14px',
        alignItems: 'center',
        color: '#fff',
        paddingLeft: 1,
        paddingRight: 1
    },
    action_row: {
        backgroundColor: '#ffff92',
        border: '1px solid #9c27b0',
        borderRadius: 2,
        padding: 1,
    },
    missing_value: {
        color: 'red',
    }
}